import '../../App.css';
import Collapsible from '../Collapsible/Collapsible';
import SelectAvis from './SelectAvis.jsx';

export default function Avis() {

    return (
        <div className='section-container section-border-top'> 
            <div className='title'>
                <div className='section-title'>Avis</div>
                <div className='HLContainer'><div className='big-line'></div></div>
            </div>
            <SelectAvis></SelectAvis>
            <Collapsible></Collapsible>
        </div>
       
    );
}